var React = require('react');

function IconPlay (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M118.4 0H9.6L0 9.6V118.4L9.6 128H118.4L128 118.4V9.6L118.4 0Z","fill":"#FFF7F4","key":0}),React.createElement("path",{"d":"M98.0746 70.0682L42.7254 102.181L32 96.1182V31.8935L42.7254 25.8398L98.0746 57.9522V70.0682Z","fill":"black","key":1})]);
}

IconPlay.defaultProps = {"width":"128","height":"128","viewBox":"0 0 128 128","fill":"none"};

module.exports = IconPlay;

IconPlay.default = IconPlay;
